module.exports = __webpack_public_path__ + "static/clickmap-77d6f170959a760f7b4e1b094ff08f7b.png";